import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function RoleBasedRedirect() {
	const { user } = useAuth();

	if (!user) return <Navigate to="/login" replace />;

	// Redirecciones según el rol del usuario
	switch (user.role) {
		case 'admin':
			return <Navigate to="/users" replace />;
		case 'user':
			return <Navigate to="/dayoff" replace />;
		case 'web':
			return <Navigate to="/dayoff" replace />;
		default:
			return <Navigate to="/login" replace />;
	}
}
